import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Typography } from '@mui/material';
import * as S from './Preloader.css';
const Preloader = ({ minHeight = 180, //px
text, size = 40, }) => (_jsxs(S.Container, Object.assign({ minHeight: minHeight }, { children: [_jsx(CircularProgress, { size: size }), text && (_jsx(Typography, Object.assign({ style: { marginTop: '1rem' }, variant: "h6" }, { children: text })))] })));
export default Preloader;
